import { useQuery } from '@tanstack/react-query';
import { STALE_TIME } from 'business/constants';
import { RQAPICallWithData } from 'store/APIClient';

import type { FieldSynopsis } from '../types';

export const useAPIGetFieldSynopsis = (
    table: string,
    field: string,
    enabled = true,
) =>
    useQuery({
        queryKey: ['datacatalog-field-synopsis', table, field],
        queryFn: async () => {
            const response = await RQAPICallWithData<FieldSynopsis>({
                endpoint: `graph/table_synopsis/${table}/${field}`,
                method: 'GET',
            });
            return response.content.data;
        },
        staleTime: STALE_TIME,
        enabled,
    });
